import { FormattedMessage } from "react-intl";

import ConfirmModal from "components/ConfirmModal";
import PreformattedText from "components/PreformattedText";
import { useTenantConfig } from "contexts/TenantConfig";

type Props = {
  onClose: () => void;
};

const CookiePolicyModal = ({ onClose }: Props): React.ReactElement => {
  const { latestCookiePolicy } = useTenantConfig();

  return (
    <ConfirmModal
      title={
        <FormattedMessage
          id="cookiePolicy.modal.title"
          defaultMessage="Cookie Policy"
        />
      }
      confirmLabel={
        <FormattedMessage
          id="cookiePolicy.modal.confirmButton"
          defaultMessage="OK"
        />
      }
      onConfirm={onClose}
    >
      <PreformattedText>{latestCookiePolicy.text}</PreformattedText>
    </ConfirmModal>
  );
};

export default CookiePolicyModal;
